"use client";
import React, { useState, useEffect } from 'react';
import styles from './BlogSpreadLoveComponent.module.css';
import { useTranslation } from 'react-i18next';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const BlogSpreadLoveComponent = ({ url, title }) => {
  const { t } = useTranslation();
  const [currentUrl, setCurrentUrl] = useState('');
  
  useEffect(() => {
    setCurrentUrl(url || window.location.href);
  }, [url]);

  const fullUrl = `https://keychoicelending.com.au${currentUrl}`;
  const shareOnFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(fullUrl)}`, '_blank');
  };

  const shareOnTwitter = () => {
    window.open(`https://x.com/intent/tweet?url=${encodeURIComponent(fullUrl)}&text=${encodeURIComponent(title)}`, '_blank');
  };

  const shareOnLinkedIn = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(fullUrl)}`, '_blank');
  };

  const shareOnInstagram = () => {
    window.open('https://www.instagram.com/keychoicelending', '_blank');
  };

  const shareViaEmail = () => {
    window.open(`mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(`Check out this article: ${currentUrl}`)}`, '_blank');
  };

  // const shareMore = () => {
  //   // If Navigator Share API is available (mobile devices)
  //   if (navigator.share) {
  //     navigator.share({
  //       title: title,
  //       url: fullUrl
  //     })
  //     .catch(error => console.log('Error sharing:', error));
  //   }
  // };

  // Don't attempt to share if URL is not yet available
  if (!currentUrl) {
    return (
      <div className={styles.spreadLoveContainer}>
        <h3 className={styles.spreadLoveTitle}>{t('Spread the love')}</h3>
        <div className={styles.socialIconsContainer}>
          <button className={`${styles.socialIconButton} ${styles.facebookButton}`} disabled>
            <FacebookIcon className={styles.socialIcon} />
          </button>
          <button className={`${styles.socialIconButton} ${styles.twitterButton}`} disabled>
            <XIcon className={styles.socialIcon} />
          </button>
          <button className={`${styles.socialIconButton} ${styles.linkedinButton}`} disabled>
            <LinkedInIcon className={styles.socialIcon} />
          </button>
          <button className={`${styles.socialIconButton} ${styles.instagramButton}`} disabled>
            <InstagramIcon className={styles.socialIcon} />
          </button>
          <button className={`${styles.socialIconButton} ${styles.emailButton}`} disabled>
            <EmailIcon className={styles.socialIcon} />
          </button>
          {/* <button className={`${styles.socialIconButton} ${styles.moreButton}`} disabled>
            <MoreHorizIcon className={styles.socialIcon} />
          </button> */}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.spreadLoveContainer}>
      <h3 className={styles.spreadLoveTitle}>{t('Spread the love')}</h3>
      <div className={styles.socialIconsContainer}>
        <button 
          className={`${styles.socialIconButton} ${styles.facebookButton}`} 
          onClick={shareOnFacebook}
          aria-label="Share on Facebook"
        >
          <FacebookIcon className={styles.socialIcon} />
        </button>
        
        <button 
          className={`${styles.socialIconButton} ${styles.twitterButton}`} 
          onClick={shareOnTwitter}
          aria-label="Share on Twitter"
        >
          <XIcon className={styles.socialIcon} />
        </button>
        
        <button 
          className={`${styles.socialIconButton} ${styles.linkedinButton}`} 
          onClick={shareOnLinkedIn}
          aria-label="Share on LinkedIn"
        >
          <LinkedInIcon className={styles.socialIcon} />
        </button>
        
        <button 
          className={`${styles.socialIconButton} ${styles.instagramButton}`} 
          onClick={shareOnInstagram}
          aria-label="Share on Instagram"
        >
          <InstagramIcon className={styles.socialIcon} />
        </button>
        
        <button 
          className={`${styles.socialIconButton} ${styles.emailButton}`} 
          onClick={shareViaEmail}
          aria-label="Share via Email"
        >
          <EmailIcon className={styles.socialIcon} />
        </button>
        
        {/* <button 
          className={`${styles.socialIconButton} ${styles.moreButton}`} 
          onClick={shareMore}
          aria-label="More sharing options"
        >
          <MoreHorizIcon className={styles.socialIcon} />
        </button> */}
      </div>
    </div>
  );
};

export default BlogSpreadLoveComponent;
